import { call, put, all } from 'redux-saga/effects';
import notify from 'devextreme/ui/notify';
import { formatMessage } from 'devextreme/localization';
import * as actions from '../actions/workingDetailing';
import { modalAddCommentClose } from '../actions/modal';
import {
  startLoading,
  stopLoading
} from '../actions/settings/loading';
import { modalErrorOpen } from '../actions/modalError';
import { post, del, get } from '../../utils/api';
import { getLocale } from '../../utils/functions';
import { imageFileTypes } from '../../components/Production/constants';

// Вызов всплывающего окна с сообщением
function openNotify(text) {
  notify(
    {
      message: text,
      height: 64,
      width: 354,
      position: {
        at: 'top center',
        my: 'top center',
        offset: '0 48'
      }
    },
    'success',
    2000
  );
}

// Добавление комментария к УЕ
export function* workingDetailingAddCommit({ payload }) {
  try {
    yield put(startLoading());
    yield call(
      post,
      '/piece/note',
      {
        pieceNumIds: payload.pieceNumIds,
        noteText: payload.noteText
      }
    );
    yield put(actions.workingDetailingAddCommitSuccess());
    // получение списка комментариев
    yield put(actions.workingDetailingGetListCommits({ pieceNumId: payload.pieceNumId }));
    yield call(openNotify, formatMessage('dataSuccess'));
    yield put(stopLoading());
    yield put(modalAddCommentClose());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

// Удаление комментария
export function* workingDetailingDelCommit({ payload }) {
  try {
    yield put(startLoading());
    yield call(del, `/piece/note/${payload.pieceNoteNumId}`);
    // получение списка комментариев
    yield put(actions.workingDetailingGetListCommits({ pieceNumId: payload.pieceNumId }));
    yield call(openNotify, formatMessage('dataSuccess'));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

// Получение списка комментариев
export function* workingDetailingGetListCommits({ payload }) {
  try {
    yield put(startLoading());
    const response = yield call(
      get,
      `/piece/note/list?pieceNumId=${payload.pieceNumId}`
    );
    yield put(actions.workingDetailingGetListCommitsSuccess(response));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

// Добавление фото
export function* workingDetailingAddPhoto({ payload }) {
  try {
    yield put(startLoading());

    yield all(payload.files.map((file) => {
      const fileType = file.name.split('.').pop();
      const formData = new FormData();
      formData.append('attachmentType', imageFileTypes.includes(`.${fileType.toLowerCase()}`) ? '0' : '1');
      formData.append('pieceNumId', payload.pieceNumId);
      formData.append('file', file);
      return call(
        post,
        '/attachment/upload/',
        formData,
        {
          headers: {
            'Accept-Language': getLocale(),
            'Content-Type': 'multipart/form-data'
          }
        }
      );
    }));
    yield put(actions.workingDetailingAddPhotoSuccess());
    yield put(actions.workingDetailingGetListPhotos({
      pieceNumId: payload.pieceNumId,
      attachmentType: 0
    }));
    yield call(openNotify, formatMessage('dataSuccess'));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

// Удаление фото
export function* workingDetailingDelPhoto({ payload }) {
  try {
    yield put(startLoading());
    // eslint-disable-next-line no-restricted-syntax
    for (const value of payload.listPhotos) {
      yield call(del, `/attachment/${value}`);
    }
    yield put(actions.workingDetailingGetListPhotos({
      pieceNumId: payload.pieceNumId,
      attachmentType: 0
    }));
    yield call(openNotify, formatMessage('dataSuccess'));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

// Список фотографий
export function* workingDetailingGetListPhotos({ payload }) {
  try {
    yield put(startLoading());
    const response = yield call(
      get,
      `/attachment/list/?attachmentType=0&pieceNumId=${payload.pieceNumId}`
    );

    const filesResponse = yield call(
      get,
      `/attachment/list/?attachmentType=1&pieceNumId=${payload.pieceNumId}`
    );
    yield put(actions.workingDetailingGetListPhotosSuccess(response));
    yield put(actions.workingDetailingGetListFilesSuccess(filesResponse));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response?.data?.message,
        techInfo: error.response?.data?.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

// Отправка email
export function* workingDetailingSendEmail({ payload }) {
  try {
    yield put(startLoading());
    yield call(
      post,
      '/piece/send-email',
      {
        emailTo: payload.emailTo,
        subject: payload.subject,
        body: payload.body,
        attachFileNames: payload.attachFileNames,
        compressAttachmentsFlag: true
      }
    );
    yield put(actions.workingDetailingSendEmailSuccess());
    yield call(openNotify, formatMessage('dataSuccess'));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}
